<template>
    <div class="col-lg-12">
        <div class="card border-top-0">

            <div class="tab-content">
                <div class="tab-pane fade show active" id="profileTab" role="tabpanel">
                    <div class="card-body personal-info">
                        <form @submit.prevent="submitForm">
                            <div class="mb-4 d-flex align-items-center justify-content-between">
                                <h5 class="fw-bold mb-0 me-4">
                                    <span class="d-block mb-2">İlaç Kartı:</span>
                                    <span class="fs-12 fw-normal text-muted text-truncate-1-line">İlaç kartlarını
                                        buradan ekleyebilirsiniz.</span>
                                </h5>
                                <div class="d-flex gap-2">
                                    <button type="submit" class="btn btn-sm btn-light-brand">Kaydet</button>
                                    <a href="javascript:void(0);" class="btn btn-sm btn-light-brand">Kaydet ve Yeni
                                        Sayfa
                                        Aç</a>
                                </div>
                            </div>
                            <div class="row mb-4 align-items-center">
                                <div class="col-lg-2">
                                    <label class="fw-semibold">İlaç Adı: </label>
                                </div>
                                <div class="col-lg-4">
                                    <div class="input-group">
                                        <input type="text" class="form-control" v-model="medicineName"
                                            placeholder="İlaç Adı">
                                    </div>
                                </div>
                                <div class="col-lg-2">
                                    <label class="fw-semibold">Barkod: </label>
                                </div>
                                <div class="col-lg-4">
                                    <div class="input-group">
                                        <input type="text" class="form-control" v-model="medicineBarcode"
                                            placeholder="Barkod">
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-4 align-items-center">
                                <div class="col-lg-2">
                                    <label class="fw-semibold">En küçük birim: </label>
                                </div>
                                <div class="col-lg-2">
                                    <div class="input-group">
                                        <select name="unit" class="form-select form-select-sm" v-model="medicineUnit">
                                            <option v-for="unit in units" :key="unit.value" :value="unit.value">
                                                {{ unit.label }}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-lg-2">
                                    <label class="fw-semibold">Bu birimdeki doz: </label>
                                </div>
                                <div class="col-lg-2">
                                    <div class="input-group">
                                        <input type="text" class="form-control" v-model="medicineDosePerUnit"
                                            placeholder="Doz">
                                    </div>
                                </div>
                                <div class="col-lg-2">
                                    <label class="fw-semibold">Başlangıç Stok Sayısı: </label>
                                </div>
                                <div class="col-lg-2">
                                    <div class="input-group">
                                        <input type="text" class="form-control" v-model="medicineInitialQuantity"
                                            placeholder="Başlangıç Stok Sayısı">
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-4 align-items-center">
                                <div class="col-lg-2">
                                    <label class="fw-semibold">Etken Madde: </label>
                                </div>
                                <div class="col-lg-2">
                                    <div class="input-group">
                                        <input type="text" class="form-control" v-model="medicineActiveIngredient"
                                            placeholder="Etken Madde">
                                    </div>
                                </div>
                                <div class="col-lg-2">
                                    <label class="fw-semibold">Kategori: </label>
                                </div>
                                <div class="col-lg-2">
                                    <div class="input-group">
                                        <input type="text" class="form-control" v-model="medicineCategory"
                                            placeholder="Kategori">
                                    </div>
                                </div>
                                <div class="col-lg-2">
                                    <label class="fw-semibold">Kullanım Amacı: </label>
                                </div>
                                <div class="col-lg-2">
                                    <div class="input-group">
                                        <input type="text" class="form-control" v-model="medicineUsagePurpose"
                                            placeholder="Kullanım Amacı">
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-4 align-items-center">
                                <div class="col-lg-2">
                                    <label class="fw-semibold">Saklama Koşulları: </label>
                                </div>
                                <div class="col-lg-4">
                                    <div class="input-group">
                                        <input type="text" class="form-control" v-model="medicineStorageConditions"
                                            placeholder="Saklama Koşulları">
                                    </div>
                                </div>
                                <div class="col-lg-2">
                                    <label class="fw-semibold">Açıklama: </label>
                                </div>
                                <div class="col-lg-4">
                                    <div class="input-group">
                                        <input type="text" class="form-control" v-model="medicineDescription"
                                            placeholder="Açıklama">
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        <!-- Medicine Package Component must be here -->
        <MedicinePackage :selectedUnitLabel="selectedUnitLabel" @update:medicinePackages="onPackagesUpdated" />
    </div>
</template>

<script>
import Swal from 'sweetalert2';
import dayjs from 'dayjs';
import MedicinePackage from '@/components/medicine/MedicinePackage.vue';

export default {
    name: 'CreateShelter',
    components: {
        MedicinePackage,
    },
    data() {
        return {
            medicineName: "",
            medicineActiveIngredient: "",
            medicineBarcode: "",
            medicineUnit: "",
            medicineDosePerUnit: 0.00,
            medicineCategory: "",
            medicineUsagePurpose: "",
            medicineStorageConditions: "",
            medicineDescription: "",
            medicineInitialQuantity: "",
            medicinePackages: [],
            units: [],
        }
    },
    async mounted() {
        await this.fetchUnits();
    },
    computed: {
        selectedUnitLabel() {
            const selected = this.units.find(unit => unit.value === this.medicineUnit);
            return selected ? selected.label : 'Seçilmedi';
        }
    },
    methods: {
        onPackagesUpdated(packages) {
            this.updatedPackages = packages;
            console.log('packages: ', this.updatedPackages);
        },
        async fetchUnits() {
            try {
                const response = await this.$axios.get('medicine_unit_choices/');
                this.units = response.data;
            } catch (error) {
                Swal.fire('Hata', error, 'error');
            }
        },
        async submitForm() {
            console.log(this.updatedPackages);
            const transformedPackages = [];
            if (this.updatedPackages != undefined) {
                const transformedPackages = this.updatedPackages.map((pack, index) => {
                    console.log('pack: ', pack);
                    const parentPack = index > 0 ? this.updatedPackages[index - 1] : null;
                    return {
                        id: pack.id || undefined,
                        package_type: pack.package_type,
                        contains_units: parseInt(pack.contains_units),
                        parent: parentPack?.id || null,
                    };
                });
            }
            console.log('transformedPackages: ', JSON.stringify(transformedPackages));
            const payload = {
                name: this.medicineName,
                active_ingredient: this.medicineActiveIngredient,
                barcode: this.medicineBarcode,
                unit: this.medicineUnit,
                dose_per_unit: this.medicineDosePerUnit,
                category: this.medicineCategory,
                usage_purpose: this.medicineUsagePurpose,
                storage_conditions: this.medicineStorageConditions,
                description: this.medicineDescription,
                initial_quantity: this.medicineInitialQuantity,
                medicine_packages: transformedPackages,
            };
            console.log('payload: ', JSON.stringify(payload));
            try {
                const response = await this.$axios.post('medicine/', payload);
                Swal.fire('Başarılı!', 'Kayıt tamamlandı.', 'success');
                this.$router.push({ name: 'Medicines', params: { page: 1 } });
            } catch (error) {
                console.log(error);

                let errorMessage = Object.entries(error.response.data)
                    .map(([key, value]) => `${key}: ${value}`)
                    .join('<br><br>');

                Swal.fire({
                    title: 'Hata!',
                    html: errorMessage,
                    icon: 'error',
                    confirmButtonText: 'Tamam'
                });
            }
        },

    }
}
</script>